import { render, staticRenderFns } from "./RailwayDetails.vue?vue&type=template&id=8e7f885e&scoped=true&"
import script from "./RailwayDetails.vue?vue&type=script&lang=js&"
export * from "./RailwayDetails.vue?vue&type=script&lang=js&"
import style0 from "./RailwayDetails.vue?vue&type=style&index=0&id=8e7f885e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7f885e",
  null
  
)

/* custom blocks */
import block0 from "./RailwayDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports